import { createSlice } from '@reduxjs/toolkit';
const sidebarSlice = createSlice({
	name: 'sidebarSlice',
	initialState: { left: false, right: false },
	reducers: {
		toggleLeftSidebar(state) {
			state.left = !state.left;
		},
		toggleRightSidebar(state) {
			state.right = !state.right;
		}
	}
});

export const { toggleLeftSidebar, toggleRightSidebar } = sidebarSlice.actions;

export default sidebarSlice.reducer;
